import script from "./AssemblyPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./AssemblyPlan.vue?vue&type=script&setup=true&lang=js"

import "./AssemblyPlan.vue?vue&type=style&index=0&id=05aec6ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05aec6ba"]])

export default __exports__